const Error404 = () => {
    return (
        <div>
            <h3>Error 404</h3>
            <p>No Encontrado</p>
        </div>
    );
}
export default Error404;
